import { render } from "./App.vue?vue&type=template&id=06a8ac6f&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=06a8ac6f&lang=css"

import exportComponent from "C:\\Users\\adel\\Documents\\photovoltaics-presentation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__